<template>
    <div class="passwordset">
        <Top name="支付密码" back email></Top>
        <div class="passwordset_w">
            <div class="pay_w">
                <van-form ref="payForm" @submit="onSubmit">
                    <div class="pay_wt">
                        <span>密码设置</span>
                        <van-password-input :value="payForm.oldPassword" gutter="5" :focused="showKeyboard" @focus="showKeyboard = true" />
                        <van-number-keyboard v-model="payForm.oldPassword" :maxlength="6" :show="showKeyboard" @blur="showKeyboard = false" />
                    </div>
                    <div class="pay_wt">
                        <span>再次确认</span>
                        <van-password-input :value="payForm.newPassword" gutter="5" :focused="showKeyboard1" @focus="showKeyboard1 = true" />
                        <van-number-keyboard v-model="payForm.newPassword" :maxlength="6" :show="showKeyboard1" @blur="showKeyboard1 = false; confirmPassword()" />
                    </div>
                    <p class="error" v-show="!isTrue">两次密码不一致</p>
                    <div class="sumbit_btn">
                        <van-button round type="info" size="large" color="linear-gradient(to right, #4a9af7, #0165da)" native-type="submit">确认修改</van-button>
                    </div>
                </van-form>
            </div>
        </div>
    </div>
</template>
<script>
import Top from '@/components/top'
export default {
    name: 'Passwordset',
    components: { Top },
    data() {
        return {
            payForm: { oldPassword: '', newPassword: '' },
            showKeyboard: false,
            showKeyboard1: false,
            isTrue: true
        }
    },
    methods: {
        onSubmit() {
            const password = this.payForm.oldPassword.trim()
            const againPassword = this.payForm.newPassword.trim()
            if (!password || !againPassword) {
                this.$toast({ duration: 1500, message: '请先完善输入框!' })
                return
            }
            if (password !== againPassword) {
                this.isTrue = false
                this.$toast({ duration: 1500, message: '两次密码不一致' })
                return
            }
            this.$api.account.securitySettings({ type: 2, password, again_password: againPassword }).then((res) => {
                if (res.code === 200) {
                    this.$toast({ message: '密码修改成功！', duration: 1500 })
                    this.$router.push('/setting')
                }
            })
        },
        confirmPassword() {
            this.isTrue = this.payForm.newPassword === this.payForm.oldPassword
        }
    }
}
</script>
<style scoped>
.pay_w { padding: 2% 3% 0; }
.passwordset_w .sumbit_btn { margin: 30% 16px 2%; }
.passwordset_w .sumbit_btn button { font-size: 1.2rem; }
.pay_wt { padding: 18px 16px 10px; position: relative; }
.pay_wt::after { position: absolute; box-sizing: border-box; content: ' '; pointer-events: none; right: 16px; bottom: 0; left: 16px; border-bottom: 1px solid #bbb; transform: scaleY(.5); }
.pay_wt > span { display: inline-block; vertical-align: middle; color: #313131; font-weight: 700; font-size: .9375rem; }
.pay_wt .van-password-input { width: 70%; display: inline-block; vertical-align: middle; }
.pay_wt .van-password-input__security { height: 2.0625rem; }
.pay_wt .van-password-input__security li { background-color: #d6d6d6; border-radius: 3px; }
.error { font-size: .5rem; color: #f00; margin-top: .5625rem; }
</style>
